import icQmark from '@/assets/ic_qmark_blue.svg';
import { useIsDesktop } from '@/hooks/useIsDesktop';

interface LayoutContainerProps {
  children: React.ReactNode;
}

const LayoutContainer = ({ children }: LayoutContainerProps) => {
  const { isDesktop } = useIsDesktop();

  return (
    <div className="mt-8 lg:mr-[400px] lg:ml-[100px]">
      {isDesktop && (
        <div className="flex gap-x-3 items-center content-center mb-8">
          <img
            alt="Gran DT - logo calendario"
            className="w-10 h-10"
            src={icQmark}
          />
          <span className={`text-lg text-[#333333] font-bold`}>
            Preguntas Frecuentes
          </span>
        </div>
      )}
      <div className="space-y-4 mx-2">{children}</div>
    </div>
  );
};

export default LayoutContainer;
